<script lang="ts">
  import type { Snippet } from "svelte"
  import type { HTMLAttributes } from "svelte/elements"
  import { fly } from "../transition"

  let {
    key,
    backward = false,
    children,
    ...props
  }: {
    key?: unknown
    backward?: boolean
    children: Snippet
  } & HTMLAttributes<HTMLDivElement> = $props()

  let [inOffsetDir, outOffsetDir] = $derived(backward ? [-1, 1] : [1, -1])
</script>

<div {...props} class={["relative w-full", props.class]}>
  <div class="invisible">{@render children()}</div>

  {#key key}
    <div
      class="absolute left-1/2 top-0 w-full -translate-x-1/2 [&:not(:nth-child(2)):not(:last-child)]:hidden"
    >
      <div
        class="w-full"
        in:fly={{ y: `${inOffsetDir * 150}%` }}
        out:fly={{ y: `${outOffsetDir * 150}%` }}
      >
        {@render children()}
      </div>
    </div>
  {/key}
</div>
